module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-9.ab5c1cf1.mp3";